var map = {
	"./About.vue": [
		"f820",
		"chunk-3c12ecc0"
	],
	"./Home.vue": [
		"bb51"
	],
	"./browseRecords.vue": [
		"b18e",
		"chunk-453b57f6"
	],
	"./classification.vue": [
		"6a7e",
		"chunk-5ac3c2a5"
	],
	"./consultingService.vue": [
		"d731",
		"chunk-e70cda36"
	],
	"./course.vue": [
		"f3c9",
		"chunk-431f759a"
	],
	"./hot.vue": [
		"bdcd",
		"chunk-5ddb842e",
		"chunk-2d21b119"
	],
	"./index.vue": [
		"1e4b",
		"chunk-06829744"
	],
	"./moreCategories.vue": [
		"c5fd",
		"chunk-2d217566"
	],
	"./newest.vue": [
		"3fd0",
		"chunk-5ddb842e",
		"chunk-2d0c5b15"
	],
	"./news.vue": [
		"1474",
		"chunk-ff499412"
	],
	"./search.vue": [
		"4e22",
		"chunk-33822b49"
	],
	"./secondary.vue": [
		"f192",
		"chunk-5269e65e"
	],
	"./videoPlay.vue": [
		"7336",
		"chunk-4b928aba"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;